var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-316.186 -33.186)"},[React.createElement("path",{"d":"M0,0H30","transform":"translate(316.894 33.893) rotate(45)","fill":"none","stroke":"#000","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M0,0H30","transform":"translate(316.894 55.107) rotate(-45)","fill":"none","stroke":"#000","strokeWidth":"2","key":1})]));
}

Close.defaultProps = {"width":"1em","height":"1em","viewBox":"0 0 22.627 22.627","stroke":"currentcolor","fill":"currentcolor","strokeWidth":"0"};

module.exports = Close;

Close.default = Close;
